/**
 * Action creator for fetching the default text templates used by
 * CustomEmailSection placeholders.
 *
 * Response key is `language` (not `local`) — this is a quirk of the
 * legacy server contract and must not be normalised here; consumers
 * mirror the legacy shape.
 *
 * Endpoint: GET /accounts/default-text
 */
export const fetchAccountDefaultTextAction = () => ({
  method: 'GET',
  endpoint: '/accounts/default-text',
});
